import cx from 'classnames';
import React, { useRef } from 'react';
import { useId } from '../hooks/use-id.js';
export const FormInputText = ({ className, externallyControlled, disabled, id, inputRef, leading, name, readOnly, selectOnFocus, trailing, value, variant = 'default', ...rest }) => {
    const uId = useId();
    const htmlId = id || uId;
    const willSelectOnFocus = selectOnFocus !== null && selectOnFocus !== void 0 ? selectOnFocus : readOnly;
    const fallbackRef = useRef(null);
    const ref = inputRef || fallbackRef;
    return (React.createElement("div", { className: cx('tds-form-input', {
            [`tds-form-input--${variant}`]: variant,
            'tds-form-input--readonly': readOnly,
            'tds--disabled': disabled,
        }, className), onClick: (e) => {
            var _a, _b, _c;
            // Autofocus input when outer div is clicked
            if (!e.target.closest('button, .tds-tooltip-wrapper') ||
                willSelectOnFocus) {
                (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus();
                // Auto-select text within the input when focused
                if (willSelectOnFocus && !((_b = document.getSelection()) === null || _b === void 0 ? void 0 : _b.toString().length)) {
                    (_c = ref.current) === null || _c === void 0 ? void 0 : _c.select();
                }
            }
        } },
        leading && React.createElement("div", { className: "tds-form-input-leading" }, leading),
        React.createElement("input", { className: "tds-form-input-text", id: htmlId, name: name, readOnly: externallyControlled || readOnly, ref: ref, value: value, disabled: disabled, ...rest }),
        trailing && React.createElement("div", { className: "tds-form-input-trailing" }, trailing)));
};
